import { z } from 'zod';

export enum Language {
  EN = 'en',
  TH = 'th',
  ZH = 'zh',
  TR_TR = 'tr-TR',
  KO_KR = 'ko-KR',
  JA_JP = 'ja-JP',
  HI_IN = 'hi-IN',
}
export class Translation {
  constructor(
    public id: string,
    public text: string,
    public translation: string,
    public sourceLanguage: Language,
    public targetLanguage: Language
  ) {
    this.id = id;
    this.text = text;
    this.translation = translation;
    this.sourceLanguage = sourceLanguage;
    this.targetLanguage = targetLanguage;
  }

  public static zodSchema = z.object({
    id: z.string(),
    text: z.string(),
    translation: z.string(),
    sourceLanguage: z.nativeEnum(Language),
    targetLanguage: z.nativeEnum(Language),
  });

  public static fromJson(json: unknown): Translation {
    const validJson = this.check(json);
    const translation = new Translation(
      validJson.id,
      validJson.text,
      validJson.translation,
      validJson.sourceLanguage,
      validJson.targetLanguage
    );
    return translation;
  }

  public static fromJsonArray(jsonArray: unknown): Translation[] {
    const validJsonArray = this.checkArray(jsonArray);
    return validJsonArray.map(
      (json) => new Translation(json.id, json.text, json.translation, json.sourceLanguage, json.targetLanguage)
    );
  }

  public static check(json: unknown): z.infer<typeof this.zodSchema> {
    return this.zodSchema.parse(json);
  }

  public static checkArray(jsonArray: unknown): z.infer<typeof this.zodSchema>[] {
    return z.array(this.zodSchema).parse(jsonArray);
  }
}

export const getMockTranslation = (overrides: Partial<Translation> = {}) => {
  return Translation.fromJson({
    id: 't-1',
    text: 'School',
    translation: 'โรงเรียน',
    sourceLanguage: Language.EN,
    targetLanguage: Language.TH,
    ...overrides,
  });
};
